import { call, put, takeLatest } from 'redux-saga/effects';

import * as shopActions from './shopActions.js';
import { updateShopApiCall } from './shopAPI.js';

function* updateShopSaga({ payload }) {
  try {
    const { data } = yield call(updateShopApiCall, payload);
    yield put(shopActions.shopUpdateStore(data));
  } catch (error) {
    yield put(shopActions.shopUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* shopWatcher() {
  yield takeLatest(shopActions.shopUpdateRequest.type, updateShopSaga);
}
